var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#004586",
    d: "M7.588 15H13v.5H6.468V4.656h.62V15z",
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 1,
    y: 1,
    stroke: "#004586",
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })));
};
export { SvgLabel as ReactComponent };
export default __webpack_public_path__ + "b5ede80374cd6463521ac21de0855142.svg";